export default __webpack_public_path__ + "static/media/mannotebook.c03fc951.png";